import { sanitizeBreakingSpaces } from "../breaking-spaces";
import {
	CENTS_BASE,
	DEFAULT_CURRENCY,
	defaultOptions,
	ICurrencyOptions,
	MIN_FRACTION_DIGITS,
} from "./utils";

// TODO adicionar teste
export function convertFromCents(value: number) {
	let _value = value;
	if (value > 0 && value < 1) {
		_value = value * 100;
	}
	return Math.abs(_value / CENTS_BASE);
}

export function convertFromCentsSigned(
	value: number,
	minimumFractionDigits: number = MIN_FRACTION_DIGITS,
) {
	return Number((value / CENTS_BASE).toFixed(minimumFractionDigits));
}

// TODO adicionar teste
export function convertToCents(value: number) {
	return Math.round(value * CENTS_BASE);
}

export function formatCurrency(value: number, options?: ICurrencyOptions) {
	const {
		language,
		currency,
		centsBase,
		withoutSymbol,
		minimumFractionDigits = MIN_FRACTION_DIGITS,
	} = {
		...defaultOptions,
		...options,
	};

	const isNegativeValue = value < 0 || options?.forceNegative;
	const formatedValue = centsBase ? convertFromCents(value) : value;

	const absValue = Math.abs(formatedValue);
	if (withoutSymbol) {
		const stringValue = absValue.toLocaleString(language, {
			minimumFractionDigits,
		});
		return isNegativeValue ? `-${stringValue}` : stringValue;
	}

	const formatter = new Intl.NumberFormat(language, {
		style: "currency",
		currency: currency || DEFAULT_CURRENCY,
		minimumFractionDigits,
	});

	const result = sanitizeBreakingSpaces(formatter.format(absValue));

	return isNegativeValue ? `-${result}` : result;
}
